<div class="row">
  <!-- <div class="col-8"> -->
  <div [ngClass]="{'col-8':showStatusBox, 'col-12':!showStatusBox}">
          <div class="collapsable-container">
          <div class="collapsable-container-header" (click)="collapsed = !collapsed">
              <div class="heading">
                  <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
                  <span class="fa fa-filter"></span> Filter: {{ FilterDescription }}
              </div>
          </div>
          <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
              <div class="row mt-3 ml-1">
                  <div class="col-12">
                      <form [formGroup]="filterFormGroup" class="">
                          <div class="row">
                              <div class="col-lg-2">
                                  <!-- Filter -->
                                  <div class="form-group row">
                                      <div class="col-lg-12">
                                          <yt-fw-date-picker-popup formControlName="DateFrom"
                                              [Label]="'FILTER.FROM-DATE'">
                                          </yt-fw-date-picker-popup>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-lg-2">
                                  <div class="form-group row">
                                      <div class="col-lg-12">
                                          <yt-fw-date-picker-popup formControlName="DateTo"
                                              [Label]="'FILTER.TO-DATE'">
                                          </yt-fw-date-picker-popup>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-lg-4">
                                  <div class="form-group row">
                                      <div class="col-lg-12">
                                          <yt-dropdown-picklist
                                              [ModelName]="'komitent'" [GetName]="'get'"
                                              [ModelProperty]="'SNaziv,Mesto'" [OrderBy]="'SNaziv'"
                                              [AllowAddNew]="false" formControlName="KomitentID"
                                              [Label]="'FAKDOKUMENT.KOMITENT.SINGULAR'" [Required]="false"
                                              (OnItemSelected)="SelectKomitent($event)"
                                              [Width]="'xl'"
                                              [Position]="'left'">
                                          </yt-dropdown-picklist>
                                      </div>
                                  </div>
                              </div>
                              <div class="mr-2">
                                  <button
                                   type="button"
                                   (click)="ApplyFilter()"
                                   class="btn btn-secondary"
                                   ngbTooltip="{{'FILTER.APPLYFILTER.TOOLTIP' | translate }}"
                                  >
                                      <span class="fa fa-search"></span>
                                  </button>
                              </div>
                              <div class="mr-2">
                                  <button type="button" (click)="ResetFilter()" class="btn btn-secondary"
                                      ngbTooltip="{{'FILTER.RESETFILTER.TOOLTIP' | translate }}">
                                      <span class="fa fa-undo"></span>
                                  </button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div *ngIf="showStatusBox" class="col-4">
      <div class="collapsable-container">
          <div class="collapsable-container-header" (click)="collapsed1 = !collapsed1">
              <div class="heading">
                  <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
                  <span *ngIf="!loadingFilter" class="fas fa-sync-alt"></span> Status: {{ StatusDescription }}
                  <span *ngIf="loadingFilter" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
              </div>
          </div>
          <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed1}" >
              <div class="row mt-3 ml-1">
                  <div class="col-12">
                      <form [formGroup]="filterFormGroup" class="">
                          <div class="row">
                              <div class="col-lg-6">
                                  <div class="form-group row mt-12" style="padding-left: 10px;">
                                      <div class="col-lg-12">
                                          <!-- Osveži status za dokumenta stara do -->
                                          {{'ULAZNIDOKUMENTDOBAVLJACA.FILTER.UVEZI.SINGULAR' | translate }}
                                      </div>
                                  </div>
                              </div>
                              <div class="col-lg-2">
                                  <div class="input-group">
                                      <input 
                                       formControlName="DanaZaOsvezavanje"
                                       type="number"
                                       min="0"
                                       step="1"
                                       max="30"
                                       class="form-control"
                                       placeholder="Broj dana"
                                      >
                                      <div class="form-error" *ngIf="this.filterFormGroup.invalid" style="position: static;">
                                        <span class="error-message"
                                          *ngIf="this.filterFormGroup.errors && this.filterFormGroup.errors.checkControls && !this.filterFormGroup.errors.checkControls.valid"><span
                                            translate="{{this.filterFormGroup.errors.checkControls.message}}"></span>
                                        </span>
                                      </div>
                                      <!-- <div *ngIf="yourForm.get('DanaZaOsvezavanje').hasError('moreThanThree')">
                                        Value must be 3 or less.
                                      </div> -->
                                  </div>                                
                              </div>
                              <div class="col-lg-2">
                                  <div class="form-group row mt-1">
                                      <div class="col-lg-12">
                                          dana
                                      </div>
                                  </div>
                              </div>                                
                              <div class="col-lg-2">
                                  <div class="form-group row">
                                      <div class="col-lg-12">
                                          <button
                                           class="btn btn-secondary"
                                           type="button"
                                           (click)="CheckInputDocumentAndRefreshStatusClick()"
                                           ngbTooltip="{{'ULAZNIDOKUMENTDOBAVLJACA.OSVEZISTATUS.TOOLTIP' | translate }}"
                                           placement="bottom"
                                           [disabled]="refreshButtonDisabled"
                                          >
                                              <span class="fas fa-sync-alt"></span>
                                          </button>
                                      </div>
                                  </div>
                              </div>                                
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>